// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2hIZq","header":"ReportDetails_header__2eeEf","title":"ReportDetails_title__3ATkH","left":"ReportDetails_left__2HdaW"};